import { Component, Input, OnInit, Optional, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { AdxVccPaymentProviderService } from '../../../finance-resource/service/adx-vcc-payment-providers.service';
import { PaymentProvider } from '../../../finance-resource/model/adx-data';

@Component({
    selector: 'fms-vcc-filter-modal',
    templateUrl: './fms-vcc-filter-modal.component.html',
    styleUrls: ['./fms-vcc-filter-modal.component.scss'],
    standalone: false
})
export class FmsVccFilterModalComponent implements OnInit, OnDestroy {
  @Input() config: any = {};

  breakPoint$?: Subscription;
  providersSubscription?: Subscription;
  isSmall: boolean = false;
  providers: PaymentProvider[] = [];
  isLoading: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<FmsVccFilterModalComponent>,
    breakpointObserver: BreakpointObserver,
    private providerService: AdxVccPaymentProviderService
  ) {
    this.breakPoint$ = breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }
  form: FormGroup = new FormGroup({
    tripReference: new FormControl(''),
    vccNumber: new FormControl('', [Validators.pattern(/^\d{0,4}$/)]),
    providerId: new FormControl(null),
    issueDateFrom: new FormControl(null),
    issueDateTo: new FormControl(null)
  });
  ngOnInit(): void {
    const { 
      tripReference, 
      vccNumber, 
      providerId, 
      virtualCreditCardIssueDateFrom, 
      virtualCreditCardIssueDateTo 
    } = this.config ?? {};
    
    this.form.patchValue({
      tripReference,
      vccNumber,
      providerId,
      issueDateFrom: virtualCreditCardIssueDateFrom,
      issueDateTo: virtualCreditCardIssueDateTo
    });
    
    if (tripReference && typeof tripReference === 'string') {
      this.form.get('tripReference')?.setValue({ value: tripReference });
    }
    
    this.isLoading = true;
    this.providersSubscription = this.providerService.getProviders().subscribe({
      next: (providers) => {
        this.providers = providers;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading payment providers', err);
        this.isLoading = false;
      }
    });
  }
  
  ngOnDestroy(): void {
    if (this.breakPoint$) {
      this.breakPoint$.unsubscribe();
    }
    if (this.providersSubscription) {
      this.providersSubscription.unsubscribe();
    }
  }

  handleFmsVccFiltersFormCloseEvent() {
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }
  }
  applyFmsVccFilters() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else if (this.dialogRef) {
      const tripReferenceValue = this.form.get('tripReference')?.value;
      this.config.tripReference = typeof tripReferenceValue === 'object'
        ? (tripReferenceValue as any)?.value || (tripReferenceValue as any)?.id || ''
        : tripReferenceValue;
      
      this.config.vccNumber = this.form.get('vccNumber')?.value;
      this.config.providerId = this.form.get('providerId')?.value;
      
      this.config.virtualCreditCardIssueDateFrom = this.form.get('issueDateFrom')?.value;
      this.config.virtualCreditCardIssueDateTo = this.form.get('issueDateTo')?.value;
      
      this.dialogRef.close(this.config);
    }
  }
  clearFmsVccFilters(field: string) {
    if (field === 'all') {
      this.form.reset();
      this.config = {};
    } else {
      this.form.get(field)?.setValue(null);
      
      if (this.config) {
        const temp = { ...this.config };
        delete temp[field as keyof any];
        
        if (field === 'issueDateFrom') {
          delete temp.virtualCreditCardIssueDateFrom;
        } else if (field === 'issueDateTo') {
          delete temp.virtualCreditCardIssueDateTo;
        }
        
        this.config = temp;
      }
    }
  }
}
